import React, { useEffect, useState } from "react";
import { usePatientBooking } from "../../lib/contexts/PatientBookingContext";

type TabsProps = {
  tabsConfig: any;
  rightSide?: any;
  fixedRight?: any;
  defaultIndex?: number;
  defaultTab?: number;
  onTabChange?: (index: number) => void;
  inline?: boolean;
};

const Tabs: React.FC<TabsProps> = ({ tabsConfig, rightSide, fixedRight, defaultIndex, defaultTab, onTabChange, inline }) => {
  const initialTab = defaultTab !== undefined ? defaultTab : (defaultIndex ?? 0);
  const [selectedIndex, setSelectedIndex] = useState(initialTab);
  const { SelectedDate } = usePatientBooking();

  useEffect(() => {
    setSelectedIndex(0);
  }, [SelectedDate]);

  // If defaultTab changes (e.g., due to search param), update selectedIndex
  useEffect(() => {
    if (defaultTab !== undefined) {
      setSelectedIndex(defaultTab);
    }
  }, [defaultTab]);

  const handleClick = (index: number) => {
    setSelectedIndex(index);
    onTabChange?.(index);
  };

  // const tabsBox: HTMLElement | null = document.querySelector(".tabs-box");
  // if (tabsBox !== null) {
  //   const arrowIcons: NodeListOf<Element> =
  //     document.querySelectorAll(".icon svg");

  //   let isDragging: boolean = false;

  //   const handleIcons = (scrollVal: number): void => {
  //     let maxScrollableWidth: number =
  //       tabsBox.scrollWidth - tabsBox.clientWidth;

  //     (arrowIcons[0].parentElement as HTMLElement).style.display =
  //       scrollVal <= 0 ? "none" : "flex";
  //     (arrowIcons[1].parentElement as HTMLElement).style.display =
  //       maxScrollableWidth - scrollVal <= 1 ? "none" : "flex";
  //   };

  //   arrowIcons.forEach((icon: Element) => {
  //     icon.addEventListener("click", () => {
  //       let scrollWidth: number = (tabsBox.scrollLeft +=
  //         icon.id === "left" ? -340 : 340);

  //       handleIcons(scrollWidth);
  //     });
  //   });

  //   const dragging = (e: MouseEvent): void => {
  //     if (!isDragging) return;
  //     tabsBox.classList.add("dragging");
  //     tabsBox.scrollLeft -= e.movementX;
  //     handleIcons(tabsBox.scrollLeft);
  //   };

  //   const dragStop = (): void => {
  //     isDragging = false;
  //     tabsBox.classList.remove("dragging");
  //   };

  //   tabsBox.addEventListener("mousedown", () => (isDragging = true));
  //   tabsBox.addEventListener("mousemove", dragging);
  //   document.addEventListener("mouseup", dragStop);
  // }

  return (
    <>
      {fixedRight ? (
        /* Single-row layout: scrollable tabs + actions | fixed search */
        <div className="flex items-center shadow-sm border-0 max-w-full xl:max-w-[80vw]">
          <div className="side_bar flex flex-1 flex-nowrap items-center gap-2 sm:gap-3 px-2 sm:px-5 text-queueText text-sm font-medium overflow-x-auto min-w-0">
            {tabsConfig.map((tab: any, index: number) => (
              <button
                key={`tab-${index}`}
                onClick={() => handleClick(index)}
                className={
                  selectedIndex === index
                    ? "tab inline-block pt-2 px-1 pb-2 text-queueHover border-b-[1px] border-queueHover rounded-t-lg min-w-max text-xs sm:text-sm"
                    : "tab inline-block pt-2 px-1 pb-2 border-b-[1px] border-transparent rounded-t-lg hover:text-gray-600 hover:border-queueText min-w-max text-xs sm:text-sm"
                }
              >
                {tab.label}
                {tab.count}
              </button>
            ))}
            {rightSide && (
              <div className="flex items-center gap-2 min-w-max ml-2">
                {rightSide}
              </div>
            )}
          </div>
          <div className="flex-shrink-0 px-2 sm:px-3 py-2">
            {fixedRight}
          </div>
        </div>
      ) : (
        /* Legacy layout: tabs on left, rightSide on right */
        <div className={`flex ${inline ? "items-center" : "flex-col lg:flex-row lg:items-center"} justify-between shadow-sm border-0 max-w-full xl:max-w-[80vw] pb-3`}>
          <div className={`side_bar flex flex-nowrap items-center px-2 sm:px-5 gap-3 sm:gap-6 md:gap-3 text-queueText text-sm font-medium overflow-x-auto ${inline ? "min-w-0 shrink" : "lg:w-[50%] xl:w-3/5"}`}>
            {tabsConfig.map((tab: any, index: number) => (
              <button
                key={`tab-${index}`}
                onClick={() => handleClick(index)}
                className={
                  selectedIndex === index
                    ? "tab inline-block pt-2 px-1 pb-2 text-queueHover border-b-[1px] border-queueHover rounded-t-lg min-w-max text-xs sm:text-sm"
                    : "tab inline-block pt-2 px-1 pb-2 border-b-[1px] border-transparent rounded-t-lg hover:text-gray-600 hover:border-queueText min-w-max text-xs sm:text-sm"
                }
              >
                {tab.label}
                {tab.count}
              </button>
            ))}
          </div>
          <div className={`${inline ? "flex items-center justify-end flex-shrink-0" : "w-full lg:w-[50%] xl:w-[50%] flex items-center md:justify-end"}`}>{rightSide}</div>
        </div>
      )}
      <div>
        {tabsConfig.map((tab: any, index: number) => (
          <div key={`tabpanel-${index}`} hidden={selectedIndex !== index}>
            {tab.content}
          </div>
        ))}
      </div>
    </>
  );
};

export default Tabs;
